import React from 'react';

import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';

import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import TagEditContent from '../edit/TagEditContent';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

type Props = {
    showEditingPopup: boolean;
    tag: Tag | null;
    shareRootPath: ImMNElement[];
    closePopup: () => void;
};

const TagEditPopup = (props: Props) => {
    const { tag, showEditingPopup, closePopup, shareRootPath } = props;
    if (!tag) return null;

    return (
        <FloatingPanel
            className="light"
            selector={`#tag-${tag.id}`}
            pollPosition
            offset={20}
            showArrow={false}
            distance={20}
            alignment={TooltipAlignment.START}
            position={TooltipPositions.RIGHT}
            show={showEditingPopup}
        >
            <PopupPanelMouseManager visible={showEditingPopup} popupId={PopupIds.TAG_EDIT_MENU} closePopup={() => {}}>
                <TagEditContent tag={tag} closePopup={closePopup} shareRootPath={shareRootPath} />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default TagEditPopup;
